import { getSystemState } from "@/features/system-states/system-state";
import { SystemStatePage } from "@/features/system-states/system-state-page";
import SysOutcomeUnknown from "@/features/system-states/sys-outcome-unknown";

export default function OutcomeUnknownPage() {
  return (
    <SystemStatePage meta={getSystemState("SYS-06")}>
      <SysOutcomeUnknown />
    </SystemStatePage>
  );
}
